module.exports = __webpack_public_path__ + "img/entry_bg.47a337bb.png";